<template>

  <div class="wrapper">
    <div class="sidebar" data-color="green" data-image="../../assets/img/sidebar-5.jpg">
      <!--
          Tip 1: You can change the color of the sidebar using: data-color="purple | blue | green | orange | red"
          Tip 2: you can also add an image using data-image tag
      -->
      <div class="sidebar-wrapper">


          <a href="#"><img src="../../assets/raefton-logo.svg" class="img-fluid p-4"></a>


        <div class="user border-0">
            <div class="info ml-4"><span id="myname">{{myself}}</span></div>
        </div>



        <ul class="nav">
          <li class="nav-item" id="navLink3">
            <a class="nav-link" href="#/contact/edit">
              <i class="nc-icon nc-circle-09"></i>
              <p>MY PROFILE</p>
            </a>
          </li>
          <li class="nav-item" id="navLink1">
            <a class="nav-link" href="#/rfq/assets">
              <i class="nc-icon nc-bus-front-12"></i>
              <p>Assets</p>
            </a>
          </li>
          <li class="nav-item" id="navLink1">
            <a class="nav-link" href="#/rfq/view">
              <i class="nc-icon nc-delivery-fast"></i>
              <p>RFQs</p>
            </a>
          </li>
          <li class="nav-item" id="navLink2">
            <a class="nav-link" v-on:click="addRFQ();">
              <i class="nc-icon nc-paper-2"></i>
              <p>CREATE RFQ</p>
            </a>
          </li>
          <li class="nav-item" id="navLink4">
            <a class="nav-link" href="#/shipment/view">
              <i class="nc-icon nc-paper-2"></i>
              <p>SHIPMENTS <span id="num_shippments"></span></p>
            </a>
          </li>
          <li class="nav-item" id="navLink3">
            <a class="nav-link" href="#/contact/view">
              <i class="nc-icon nc-circle-09"></i>
              <p>CONTACTS</p>
            </a>
          </li>
          <li class="nav-item ">
            <a class="nav-link" href="#/auth/login">
              <i class="nc-icon nc-button-power"></i>
              <p>SIGN OUT</p>
            </a>
          </li>

        </ul>
      </div>
      <div class="sidebar-background" style="background-image: url(../static/img/sidebar-5.jpg) "></div>
    </div>
    <div class="main-panel">
      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg ">
        <div class="container-fluid">
          <div class="navbar-wrapper">
            <div class="navbar-minimize">
              <button id="minimizeSidebar" class="btn btn-success btn-fill btn-round btn-icon d-none d-lg-block">
                <i class="fa fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i class="fa fa-navicon visible-on-sidebar-mini"></i>
              </button>
            </div>
            <a class="navbar-brand" href="#pablo" id="test"> Assets</a>
          </div>
          <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
          </button>

        </div>
      </nav>
      <!-- End Navbar -->

      <!-- Empty State -->
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col">
              <p class="text-center">You don't currently have any assets added. Please click one of the Add buttons to get started.</p>
              <p class="text-center">
                <button class="btn btn-primary btn-wd"><i class="fa fa-plus"></i> Add a Tractor</button>
                <button class="btn btn-primary btn-wd"><i class="fa fa-plus"></i> Add a Trailer</button>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- End Empty State -->

      <!-- Non-empty state -->
      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">
                      <div class="card data-tables">
                          <div class="card-body table-no-bordered dataTable dtr-inline table-full-width">
                              <!-- convert this to a datatable like in other sections of the site -->
                              <div class="fresh-datatables">
                                  <table id="datatables_contacts" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                    <thead>
                                      <tr>
                                        <th>Make</th>
                                        <th>Model</th>
                                        <th>ID</th>
                                        <th>Type</th>
                                        <th class=" text-right">Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="align-top">Volvo</td>
                                        <td class="align-top">VNR</td>
                                        <td class="align-top">200112</td>
                                        <td class="align-top">Tractor</td>
                                        <td class=" text-right"><a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-pencil"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a></td>
                                      </tr>
                                      <tr>
                                        <td class="align-top">Volvo</td>
                                        <td class="align-top">VNR</td>
                                        <td class="align-top">342123</td>
                                        <td class="align-top">Tractor</td>
                                        <td class=" text-right"><a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-pencil"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a></td>
                                      </tr>
                                      <tr>
                                        <td class="align-top">Great Dane</td>
                                        <td class="align-top">Freedom SE</td>
                                        <td class="align-top">332938</td>
                                        <td class="align-top">Trailer</td>
                                        <td class=" text-right"><a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-pencil"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a></td>
                                      </tr>
                                      <tr>
                                        <td class="align-top">Great Dane</td>
                                        <td class="align-top">Freedom SE</td>
                                        <td class="align-top">74443</td>
                                        <td class="align-top">Trailer</td>
                                        <td class=" text-right"><a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-pencil"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a></td>
                                      </tr>
                                    </tbody>
                                  </table>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button class="btn btn-primary btn-wd"><i class="fa fa-plus"></i> Add a Tractor</button>
                  <button class="btn btn-primary btn-wd"><i class="fa fa-plus"></i> Add a Trailer</button>
                </div>
              </div>
          </div>
      </div>
      <!-- End Non-empty state -->

      <footer class="footer">
        <div class="container">
          <nav>
            <p class="copyright text-center">
              &copy; 2018 Raefton
            </p>
          </nav>
        </div>
      </footer>
    </div>
  </div>





</template>

<script>
  import router from '../../router'
  import apiService from '../../services/api.service'
  import config from '../../config'

  import "../../../static/js/jquery.dataTables.min.js"


  export default {
    name: 'Demo',
    data: function() {
      return {
        user: '',
        password: '',
        myname: 'Timmyy',
      }
    },
    mounted: function() {
      console.log("mounted------");
      initTables();
    },

    methods: {


    }
  }

  function initTables() {

    var vm = this;
    console.log( "test: " + $("#test").html() );


    var testdata = {
      "data": [
        {
          "customer": "John James",
          "shipper": "Pat Crossman",
          "consignee": "Jimmy C. Gerry",
          "created_date": "Mon Dec 18, 2017",
          "due_date": "Mon Dec 28, 2017",
          "status": '<strong>Assigned <i class="fa fa-square rfq_received"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
        {
          "customer": "John James II",
          "shipper": "Pat Crossman II",
          "consignee": "Jimmy C. Gerry II",
          "created_date": "Mon Dec 18, 2018",
          "due_date": "Mon Dec 28, 2018",
          "status": '<strong>Assigned <i class="fa fa-square rfq_declined"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
        {
          "customer": "Brian G. Baldree",
          "shipper": "Pat Crossman II",
          "consignee": "Jimmy C. Gerry II",
          "created_date": "Mon Dec 18, 2018",
          "due_date": "Mon Dec 28, 2018",
          "status": '<strong>Assigned <i class="fa fa-square rfq_viewed"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
      ]};



    var mytable = $('#datatables').DataTable({
         "data": testdata.data,
         "columns": [
             {
                 "className": 'details-control',
                 "orderable": false,
                 "defaultContent": '',
                 "render": function () {
                     return '<i class="fa fa-plus-square" aria-hidden="true"></i>';
                 },
             },
             { "data": "customer" },
             { "data": "shipper" },
             { "data": "consignee" },
             { "data": "created_date" },
             { "data": "due_date" },
             { "data": "status" },
             { "data": "actions", "className": 'text-right' },
         ],

        "pagingType": "full_numbers",
        "lengthMenu": [
            [10, 25, 50, -1],
            [10, 25, 50, "All"]
        ],
        retrieve: true,
        responsive: true,
        language: {
            search: "_INPUT_",
            searchPlaceholder: "Search records",
        }

    });


    // Add event listener for opening and closing details
    $('#datatables tbody').on('click', 'td.details-control', function () {
        var tr = $(this).closest('tr');
        var row = mytable.row(tr);
        var tdi = tr.find("i.fa");

        if ( row.child.isShown() ) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            tdi.first().removeClass('fa-minus-square');
            tdi.first().addClass('fa-plus-square');

        }
        else {
            // Open this row
            row.child( formatDetailRow(row.data()) ).show();
            tr.addClass('shown');
            tdi.first().removeClass('fa-plus-square');
            tdi.first().addClass('fa-minus-square');
            // setTimeout( function() { tr.next().find("td").attr("colspan", "15").attr("width", "100%") }, 1000);
        }
    } );

    console.log("datatables init done!");
  }

  // https://datatables.net/examples/api/row_details.html
  function formatDetailRow ( d ) {

    // d is the original data object for the row
    // console.log( JSON.stringify(d) );

    return '<table class="table">'+
      '<thead>'+
          '<tr>'+
            '<th>Assignee</th>'+
            '<th>Assign Data</th>'+
            '<th>Due Date</th>'+
            '<th>Status</th>'+
            '<th>Total Quote</th>'+
            '<th class="text-right">Actions</th>'+
          '</tr>'+
      '</thead>'+
      '<tbody>'+
        '<tr>'+
          '<td>Eva Solomon</td>'+
          '<td>Mon Dec 18, 2017</td>'+
          '<td>Tue Dec 19, 2017</td>'+
          '<td>Open</td>'+
          '<td>$500.00</td>'+
          '<td class="text-right"><a href="#" class="btn btn-link btn-primary"><i class="fa fa-fw fa-plus"></i></a></td>'+
        '</tr>'+
      '</tbody>'+
    '</table>';

    /*
    return "colspan all of this now";


    return [
        'First child row',
        'Second child row',
        'Third child row'
    ];*/

  }


  // https://vuejsdevelopers.com/2017/04/22/vue-js-libraries-plugins/
  // https://laracasts.com/discuss/channels/vue/using-datatables-with-vue


</script>



// WEBPACK FOOTER //
// t_assets.vue?938f11f8